import * as THREE from "three/webgpu";
import { celestialTheme } from "../../design/celestialTheme";
import type { PresentedNode } from "../../presentation/mesh";
import type { ResourceRegistry } from "../core/ResourceRegistry";

export function addCelestialOntologyAccent(root: THREE.Group, node: PresentedNode, resources: ResourceRegistry) {
  if (node.archetype === "black-hole" || node.kind === "system") return;
  const palette = celestialTheme.clusters[node.cluster];
  const material = new THREE.MeshBasicNodeMaterial();
  material.color = new THREE.Color(palette.secondary).multiplyScalar(1.05);
  material.opacity = node.kind === "artifact" ? 0.22 : 0.16;
  material.transparent = true;
  material.depthWrite = false;
  material.toneMapped = false;
  material.blending = THREE.AdditiveBlending;
  resources.material(material);

  const radius = node.kind === "location" ? 0.52 : node.kind === "goal" ? 0.46 : 0.38;
  const tube = node.kind === "artifact" ? 0.008 : 0.005;
  const geometry = resources.geometry(new THREE.TorusGeometry(radius, tube, 6, 96));
  const ring = new THREE.Mesh(geometry, material);
  ring.rotation.x = node.kind === "location" ? 1.1 : 0.82;
  ring.rotation.z = node.kind === "goal" ? 0.78 : -0.32;
  ring.userData.decorative = true;
  root.add(ring);

  if (node.kind !== "artifact") return;
  const second = new THREE.Mesh(geometry, material);
  second.rotation.set(0.44, 0.2, 1.18);
  second.scale.setScalar(0.78);
  second.userData.decorative = true;
  root.add(second);
}
